import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { BottomSectionComponent } from "./bottom-section/bottom-section.component";
import { ContactIconsBlockComponent } from "./bottom-section/contact-icons-block/contact-icons-block.component";
import { ContactSectionModule } from "./contact-section/contact-section.module";
import { LoadingIndicatorComponent } from "./loading-indicator.component";
import { SharedComponentsModule } from "./shared-components/shared-components.module";
import { SpotlightSectionModule } from "./spotlight-section/spotlight-section.module";

@NgModule({
  declarations: [
    AppComponent,
    BottomSectionComponent,
    ContactIconsBlockComponent,
    LoadingIndicatorComponent,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: "serverApp" }),
    SpotlightSectionModule,
    ContactSectionModule,
    SharedComponentsModule,
    HttpClientModule,
  ],
  entryComponents: [LoadingIndicatorComponent],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
